import { stampMeetingClock } from '../utils/meetingClock';
import api from '../api';

const meetingService = {
    // List all meetings for the authenticated user with pagination
    list: async (page = 1, perPage = 10) => {
        return api.get('/meetings', {
            params: { page, per_page: perPage }
        });
    },

    // Create a new scheduled meeting (alias for store, used by ScheduleMeetingLandingModal)
    createMeeting: async (data) => {
        return api.post('/meetings', data);
    },

    // Create a new scheduled meeting (legacy method name)
    store: (payload) => api.post('/meetings', payload),

    // Fetch available users for invite dropdown
    getAvailableUsers: async () => {
        return api.get('/users');
    },

    // Get details for a specific meeting
    show: (id) => api.get(`/meetings/${id}`),

    // Update an existing meeting
    update: (id, payload) => api.put(`/meetings/${id}`, payload),
    updateMeeting: (id, payload) => api.put(`/meetings/${id}`, payload),

    // Cancel a meeting with a reason
    cancel: (id, reason) => api.post(`/meetings/${id}/cancel`, { reason }),

    // Join a meeting (gets Agora token and channel)
    join: (id, occurrenceDate = null) => api.post(`/meetings/${id}/join`, null, {
        params: occurrenceDate ? { occurrence_date: occurrenceDate } : {},
    }).then(stampMeetingClock),

    // RSVP to a meeting invite
    rsvp: (id, status) => api.post(`/meetings/${id}/rsvp`, { rsvp_status: status }),

    // Propose a new time for a meeting
    proposeTime: (id, payload) => api.post(`/meetings/${id}/propose-time`, payload),

    // List proposed times for a meeting
    listProposals: (id) => api.get(`/meetings/${id}/proposals`),

    // List requester's own time proposals for a meeting
    listMyProposals: (id) => api.get(`/meetings/${id}/my-proposals`),

    // Complete meeting time proposal actions
    acceptProposal: (id, proposalId) => api.post(`/meetings/${id}/proposals/${proposalId}/accept`),
    rejectProposal: (id, proposalId) => api.post(`/meetings/${id}/proposals/${proposalId}/reject`),

    // Availability check
    checkAvailability: (payload) => api.post('/meetings/availability', payload),

    // Attachment management
    listAttachments: (id) => api.get(`/meetings/${id}/attachments`),
    uploadAttachments: (id, formData) => api.post(`/meetings/${id}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteAttachment: (id, attachmentId) => api.delete(`/meetings/${id}/attachments/${attachmentId}`),

    // Remove a member from a meeting
    removeMember: (id, userId) => api.delete(`/meetings/${id}/members/${userId}`),
    removeGuestInvite: (id, guestInviteId) => api.delete(`/meetings/${id}/guest-invites/${guestInviteId}`),

    // Public external guest invite flow
    getPublicInvite: (token) => api.get(`/public/meeting-invites/${token}`),
    joinPublicInvite: (token, occurrenceDate = null) => api.post(`/public/meeting-invites/${token}/join`, null, {
        params: occurrenceDate ? { occurrence_date: occurrenceDate } : {},
    }).then(stampMeetingClock),

    // Forward request management
    createForwardRequest: (meetingId, inviteeId, scope) =>
        api.post(`/v1/meetings/${meetingId}/forward-requests`, {
            invitee_id: inviteeId,
            scope: scope,
        }),

    getForwardRequests: (meetingId, status = 'pending') =>
        api.get(`/v1/meetings/${meetingId}/forward-requests`, {
            params: { status }
        }),

    acceptForwardRequest: (meetingId, requestId) =>
        api.patch(`/v1/meetings/${meetingId}/forward-requests/${requestId}/accept`),

    rejectForwardRequest: (meetingId, requestId, rejectionReason = null) =>
        api.patch(`/v1/meetings/${meetingId}/forward-requests/${requestId}/reject`, {
            rejection_reason: rejectionReason
        }),

    getMyForwardRequests: (meetingId) =>
        api.get('/v1/my-forward-requests', {
            params: { meeting_id: meetingId }
        }),

    getAttachmentOnlyOfficeConfig: (meetingId, attachmentId) =>
        api.get(`/meetings/${meetingId}/attachments/${attachmentId}/onlyoffice-config`),

    getTranscription: (id) => api.get(`/meetings/${id}/transcription`),
    triggerTranscription: (id) => api.post(`/meetings/${id}/transcribe`),
};

export default meetingService;
